// extracted by mini-css-extract-plugin
export default {"wrapper":"Detial_wrapper__jqTj0","col":"Detial_col__slzSD","reset_form_style":"Detial_reset_form_style__8s+Hg"};